export const RegionSelectionConstants = {
    NOT_STARTED : "NOT_STARTED",
    GETTING_IMAGE : "GETTING_IMAGE",
    FETCHED_IMAGE : "FETCHED_IMAGE",
    SELECTION_DONE : "SELECTION_DONE",
    CONFIRMED : "CONFIRMED",
    ERRORED_OUT : "ERRORED_OUT",
    CANCELLED : "CANCELLED",
    COARSE_STARTED : "COARSE_STARTED",
    COARSE_DONE:"COARSE_DONE",
    START_DROP_DISTANCE_SELECTION : "START_DROP_DISTANCE_SELECTION",
    START_FOCUS_POINTS_SELECTION : "START_FOCUS_POINTS_SELECTION"
}